export default __webpack_public_path__ + "static/media/firework-active.1ad612bb.svg";